import type { ReactNode } from 'react';
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { Heading } from '@noths/polaris-client-ribbons-design-system';

import { LinksBanner } from './LinksBanner';
import * as styles from './LinksBlock.styles';

export interface LinksBlockProps {
  title: string;
  subHeading: string;
  imageUrl: string;
  imageAlt: string;
  backgroundColor: string;
  children: ReactNode;
  onVisible?: () => void;
}

export const LinksBlock = ({
  title,
  subHeading,
  imageUrl,
  imageAlt,
  backgroundColor,
  children,
  onVisible = () => {},
}: LinksBlockProps) => {
  const { observedElementRef } = useVisibilityObserver(() => onVisible());
  return (
    <div ref={observedElementRef}>
      <Heading css={styles.title} level={2}>
        {title}
      </Heading>
      <p css={styles.subHeading}>{subHeading}</p>
      <LinksBanner
        subHeading={subHeading}
        backgroundColor={backgroundColor}
        imageUrl={imageUrl}
        imageAlt={imageAlt}
      >
        <div css={styles.linksBlock}>{children}</div>
      </LinksBanner>
    </div>
  );
};
